import {Routes} from '@angular/router';
import {DashboardPageComponent} from "./pages/dashboard-page/dashboard-page.component";
import {inject} from "@angular/core";
import {AuthService} from "./services/auth.service";
import {UserPageComponent} from "./pages/user-page/user-page.component";
import {ApplicationsTabComponent} from "./pages/applications-tab/applications-tab.component";
import {ApartmentPageComponent} from "./pages/apartment-page/apartment-page.component";
import {ApartmentsTabComponent} from "./pages/dashboard-page/apartments-tab/apartments-tab.component";
import {EmailsTabComponent} from "./pages/dashboard-page/emails-tab/emails-tab.component";
import {CancelTabComponent} from "./pages/cancel-tab/cancel-tab.component";
import {BetterUsersOverviewComponent} from "./pages/better-users-overview/better-users-overview.component";
import {DelayedApplicationsTabComponent} from "./pages/delayed-applications-tab/delayed-applications-tab.component";
import {NotificationTestPageComponent} from "./pages/notification-test-page/notification-test-page.component";
import {InAppNotificationTestPageComponent} from "./pages/in-app-notification-test-page/in-app-notification-test-page.component";
import {ExportsTabComponent} from "./pages/exports-tab/exports-tab.component";
import {DomainEventsPageComponent} from "./pages/domain-events-page/domain-events-page.component";
import {ManualNotificationCheckPageComponent} from "./pages/manual-notification-check-page/manual-notification-check-page.component";
import {ApplicationCreatePageComponent} from "./pages/application-create-page/application-create-page.component";
import {ConfigTabComponent} from "./pages/config-tab/config-tab.component";
import {RegistrationPageComponent} from "./pages/registration-page/registration-page.component";
import {CommandForUsersPageComponent} from "./pages/command-for-users-page/command-for-users-page.component";
import {MarketingSmsTabComponent} from "./pages/marketing-sms-tab/marketing-sms-tab.component";
import {FeedbackTabComponent} from "./pages/feedback-tab/feedback-tab.component";
import {RatingsTabComponent} from "./pages/ratings-tab/ratings-tab.component";
import {MarketResearchQuestionsTabComponent} from "./pages/market-research-questions-tab/market-research-questions-tab.component";

export const routes: Routes = [
  {
    path: '',
    component: DashboardPageComponent,
    canActivate: [() => inject(AuthService).authorize()],
    children: [
      {
        path: '',
        pathMatch: "full",
        redirectTo: 'nyc-sync'
      },
        {
          path: 'users',
          children: [
            {
              path: '',
              pathMatch: "full",
              component: BetterUsersOverviewComponent,
              data: {
                tab: 'users'
              }
            },
            {
              path: ':userId/notification-test',
              component: NotificationTestPageComponent,
              data: {
                tab: 'users'
              }
            },
            {
              path: ':userId/in-app-notification-test',
              component: InAppNotificationTestPageComponent,
              data: {
                tab: 'users'
              }
            },
            {
              path: ':userId/application-create',
              component: ApplicationCreatePageComponent,
              data: {
                tab: 'users'
              }
            },
            {
              path: ':userId',
              component: UserPageComponent,
              data: {
                tab: 'users'
            }
          }
        ]
      },
      {
        path: 'apartments',
        children: [
          {
            path: ":apartmentId",
            component: ApartmentPageComponent,
            data: {
              tab: 'apartments'
            }
          },
          {
            path: "",
            pathMatch: "full",
            component: ApartmentsTabComponent,
            data: {
              tab: 'apartments'
            }
          },
        ]
      },
      {
        path: "emails",
        children: [
          {
            path: '',
            pathMatch: "full",
            component: EmailsTabComponent,
            data: {
              tab: 'emails'
            }
          }
        ]
      },
      {
        path: 'failed-applications',
        children: [
          {
            path: '',
            pathMatch: "full",
            component: ApplicationsTabComponent,
            data: {
              tab: 'failed-applications'
            }
          },
        ]
      },
      {
        path: 'delayed-applications',
        children: [
          {
            path: '',
            pathMatch: "full",
            component: DelayedApplicationsTabComponent,
            data: {
              tab: 'delayed-applications'
            }
          },
        ]
      },
      {
        path: "cancels",
        component: CancelTabComponent
      },
      {
        path: "exports",
        component: ExportsTabComponent,
        data: {
          tab: 'exports'
        }
      },
      {
        path: "domain-events",
        component: DomainEventsPageComponent,
        data: {
          tab: 'domain-events'
        }
      },
      {
        path: 'notification-check',
        component: ManualNotificationCheckPageComponent,
        data: {
          tab: 'notification-check'
        }
      },
{
        path: 'nyc-sync',
        component: RegistrationPageComponent,
        data: {
          tab: 'nyc-sync'
        }
      },
      {
        path: 'command-for-users',
        component: CommandForUsersPageComponent,
        data: {
          tab: 'command-for-users'
        }
      },
      {
        path: 'config',
        component: ConfigTabComponent,
        data: {
          tab: 'config'
        }
      },
      {
        path: 'marketing-notification',
        component: MarketingSmsTabComponent,
        data: {
          tab: 'marketing-notification'
        }
      },
      {
        path: 'feedback',
        component: FeedbackTabComponent,
        data: {
          tab: 'feedback'
        }
      },
      {
        path: 'ratings',
        component: RatingsTabComponent,
        data: {
          tab: 'ratings'
        }
      },
      {
        path: 'market-research-questions',
        component: MarketResearchQuestionsTabComponent,
        data: {
          tab: 'market-research-questions'
        }
      }
    ]
  },
  {
    path: 'callback',
    redirectTo: '',
  }
];
